import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Box, Icon, TransparentButton } from '@redriverpress/system'
import DOMPurify from 'dompurify'
import parse, { attributesToProps } from 'html-react-parser'
import LightboxImage from 'Common/components/LightboxImage'
import styled from 'styled-components'

const sanitizeOptions = {
  ADD_TAGS: ['iframe'],
  ADD_ATTR: ['frameborder', 'allowfullscreen', 'allow'],
}

const Overlay = styled(Box)`
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  inset: 0;
  z-index: ${props => props.zIndex};
`

const parseOptions = {
  replace: domNode => {
    if (domNode.name === 'img') {
      const { src, alt } = attributesToProps(domNode.attribs)
      return <LightboxImage src={src} alt={alt} />
    }
  },
}

export default function TutorialVideo({
  open,
  onOpenChange,
  videoId,
  ...props
}) {
  const [propVideoId, setPropVideoId] = useState(null)

  const content = `<div class='videoWrapper'><iframe title='video-iframe' allow='autoplay;fullscreen' allowfullscreen='' frameborder='0' height='360' src='https://player.vimeo.com/video/${propVideoId}' width='640'></iframe></div>`
  const sanitizedContent = DOMPurify.sanitize(content, sanitizeOptions)

  useEffect(() => {
    open ? setPropVideoId(videoId) : setPropVideoId(null)
  }, [open])

  return (
    <>
      <Box
        mb={4}
        position='fixed'
        width='90%'
        height='fit-content'
        maxWidth='800px'
        top='5vh'
        bottom='0'
        left='0'
        right='0'
        margin='0 auto'
        {...props}
      >
        <TransparentButton
          aria-label='Close lightbox'
          p={3}
          onClick={() => onOpenChange(false)}
          bg='white'
          borderRadius='circular'
          size={3}
          display='flex'
          justifyContent='center'
          alignItems='center'
          position='fixed'
          right={10}
          top={10}
          zIndex={1}
        >
          <Icon icon='times' fontSize={3} />
        </TransparentButton>
        {propVideoId && parse(sanitizedContent, parseOptions)}
      </Box>
      <Overlay
        zIndex={6}
        display={open ? 'block' : 'none'}
        onClick={() => onOpenChange(false)}
      />
    </>
  )
}

TutorialVideo.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  videoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
